import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'org-overview',
      title: `Organization Settings <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'View and edit your organization\'s core settings. Changes here affect how your financial data is structured and reported.',
      attachTo: { element: '[data-tour="org-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'org-details',
      title: `Organization Details <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Update your organization name, type, and Tax ID/EIN. The organization type determines which features and report templates are available.',
      attachTo: { element: '[data-tour="org-details"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'org-fiscal-year',
      title: `Financial Year <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Set when your financial year starts. <strong>This affects all date-based reports</strong> \u2014 the Income Statement defaults to your financial year-to-date, and budget periods align to this date.',
      attachTo: { element: '[data-tour="org-fiscal-year"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'org-members',
      title: `Members <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'View and manage who has access to this organization. Roles include <strong>Admin</strong> (full access), <strong>Bookkeeper</strong> (transactions & reports), <strong>Auditor</strong> (read-only reports), and <strong>Subscriber</strong> (basic view).',
      attachTo: { element: '[data-tour="org-members"]', on: 'right' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'orgManagement',
  pathPattern: '/account/org-management',
  getSteps,
  label: 'Organization Management Tour',
});
